import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import PF2MTabs from '~/components/PF2MTabs';
import TasksTab from './TasksTab';
import TaskTypesTab from './TaskTypesTab';

const Tasks = ({
  setAlertDialog: setModal,
  isChecklistMapsDirty,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:TaskCodeType') },
    { key: 1, label: translate('common:TaskCodes') },
  ];

  const handleChange = (event, value) => {
    const blockChange = value === 0 && isChecklistMapsDirty;
    if (blockChange) {
      event.preventDefault();
      setModal();
    } else {
      setSelectedTab(value);
    }
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<TaskTypesTab />) : null}
      {selectedTab === 1 ? (<TasksTab />) : null}
    </>
  );
};


Tasks.propTypes = {
  setAlertDialog: PropTypes.func,
  isChecklistMapsDirty: PropTypes.bool,
};

Tasks.defaultProps = {
  setAlertDialog: () => { },
  isChecklistMapsDirty: false,
};

export default (withStyles(styles)(Tasks));
